module.exports = __webpack_public_path__ + "static/media/attendee_solo.37bf7cb1.svg";